import { Text } from '@chakra-ui/react';
import { TextLink } from '@time-line/components/common';
import type { ColorScheme } from 'components/heros/PromotionHero';
import { useSiteSpecificRoutes } from 'hooks/useSiteSpecificRoutes';
import NextLink from 'next/link';

const TERMS_COPY = {
  sms: 'By signing up for texts, you consent to receive marketing text messages (e.g. promos, cart reminders) from Timeline at the number provided, including messages sent by autodialer. Consent is not a condition of purchase. Msg & data rates may apply. Msg frequency varies. Unsubscribe at any time by replying STOP or clicking the unsubscribe link (where available).',
  email:
    'Yes, I would like to receive email updates from Timeline. Unsubscribe anytime.',
};

interface SubscribeTermsProps {
  consentType: 'email' | 'sms';
  colorScheme: ColorScheme;
}

export function SubscribeTerms({
  consentType,
  colorScheme,
}: SubscribeTermsProps) {
  const [PRIVACY_POLICY, TERMS] = useSiteSpecificRoutes([
    'PRIVACY_POLICY',
    'TERMS',
  ]);

  return (
    <Text
      textAlign={{
        base: 'center',
        md: 'left',
      }}
      size="detail"
      color={colorScheme === 'white' ? 'whiteAlpha.700' : 'blackAlpha.700'}
    >
      {TERMS_COPY[consentType]}{' '}
      <TextLink
        as={NextLink}
        variant="underline"
        href={PRIVACY_POLICY}
        textProps={{
          size: 'detail',
        }}
      >
        Privacy Policy
      </TextLink>{' '}
      &{' '}
      <TextLink
        as={NextLink}
        variant="underline"
        href={TERMS}
        textProps={{
          size: 'detail',
        }}
      >
        Terms
      </TextLink>
      .
    </Text>
  );
}
